module.exports = __webpack_public_path__ + "img/picture_white.1e779e70.svg";